import React from 'react';
import { Table } from 'reactstrap';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import SortableTh from '@src/components/SortableTh/SortableTh';

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh
            {...props}
            label={'Association Name'}
            field={'Associations.name'}
          />
          <SortableTh
            {...props}
            label={'Type'}
            field={'AssociationTypes.name'}
          />
          <SortableTh {...props} label={'Address'} field={'address'} />
          {props.showManagementCompany && (
            <SortableTh
              {...props}
              label={'Management Company'}
              field={'ManagementCompanies.name'}
            />
          )}
          <SortableTh
            {...props}
            label={'Status'}
            field={'Associations.status'}
          />
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          return (
            <tr
              className={'pointer'}
              key={'association-' + item.id}
              onClick={() => props.onEntityClick(item.id)}
            >
              <td>{item.name}</td>
              <td>{item.association_type.name}</td>
              <td>
                <AddressHelper {...item} />
              </td>
              {props.showManagementCompany && (
                <td>
                  {item.management_company === null
                    ? '---'
                    : item.management_company.name}
                </td>
              )}
              <td>{item.status === 1 ? 'Active' : 'Inactive'}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
